module.exports = __webpack_public_path__ + "img/image0.79f39f7b.webp";